function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { cloneElement, useCallback, useEffect, useState, useRef } from "react";
import { Popper } from "../Popper";
import useStyle from "./Flyout.style";
import Portal from "../Portal";
export var Flyout = function(param) {
    var accessibilityLabel = param.accessibilityLabel, arrowLabel = param.arrowLabel, arrowPadding = param.arrowPadding, _arrowSize = param.arrowSize, arrowSize = _arrowSize === void 0 ? 'medium' : _arrowSize, content = param.content, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, flyoutStyles = param.flyoutStyles, id = param.id, _isFixed = param.isFixed, isFixed = _isFixed === void 0 ? false : _isFixed, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _largeCaret = param.largeCaret, largeCaret = _largeCaret === void 0 ? false : _largeCaret, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _onOpen = param.onOpen, onOpen = _onOpen === void 0 ? function() {} : _onOpen, _placement = param.placement, placement = _placement === void 0 ? 'bottom' : _placement, _popperjsModifiers = param.popperjsModifiers, popperjsModifiers = _popperjsModifiers === void 0 ? [] : _popperjsModifiers, portal = param.portal, _preventOverflow = param.preventOverflow, preventOverflow = _preventOverflow === void 0 ? true : _preventOverflow, testID = param.testID, transitionProps = param.transitionProps, trigger = param.trigger, zIndex = param.zIndex;
    var ref = _slicedToArray(useState(defaultOpen), 2), isOpen = ref[0], setIsOpen = ref[1];
    var triggerRef = useRef(null);
    var popperRef = useRef(null);
    var handleOpen = useCallback(function() {
        onOpen();
        setIsOpen(true);
    }, [
        onOpen
    ]);
    var handleClose = useCallback(function() {
        onClose();
        setIsOpen(false);
    }, [
        onClose
    ]);
    var toggleOpen = function() {
        if (isOpen) {
            handleClose();
        } else {
            handleOpen();
        }
    };
    var accessibilityClick = function(event) {
        var code = event.charCode || event.keyCode;
        if (code === 32 || code === 13) {
            toggleOpen();
        }
    };
    useEffect(function() {
        if (isOpen) {
            var handleEsc = function(event) {
                var code = event.charCode || event.keyCode;
                if (code === 27 && isOpen) {
                    handleClose();
                }
            };
            window.addEventListener('keydown', handleEsc);
            return function() {
                return window.removeEventListener('keydown', handleEsc);
            };
        }
    }, [
        handleClose,
        isOpen
    ]);
    var ref1 = useStyle(largeCaret, noPadding, isRtl), flyoutContainerStyles = ref1.flyoutContainerStyles, popperStyles = ref1.popperStyles, triggerWrapperStyles = ref1.triggerWrapperStyles;
    var returnedContent = typeof content === 'function' ? content(handleClose) : content;
    var correctedArrowSize = !!largeCaret ? 'large' : arrowSize;
    var correctedArrowPadding = arrowPadding;
    if (typeof correctedArrowPadding === 'undefined') {
        if (correctedArrowSize === 'small') {
            correctedArrowPadding = 15;
        } else if (correctedArrowSize === 'medium') {
            correctedArrowPadding = 18;
        } else if (correctedArrowSize === 'large') {
            correctedArrowPadding = 24;
        }
    }
    var correctedPreventOverflow = portal ? false : preventOverflow;
    return _jsxs("div", {
        css: _objectSpread({}, flyoutContainerStyles, flyoutStyles),
        children: [
            _jsx("div", {
                ref: triggerRef,
                css: triggerWrapperStyles,
                children: typeof trigger === 'function' ? trigger(toggleOpen) : cloneElement(trigger, {
                    tabIndex: 0,
                    onClick: toggleOpen,
                    onKeyPress: function(event) {
                        event.preventDefault();
                        accessibilityClick(event);
                    },
                    forwardedRef: popperRef
                })
            }),
            _jsx(Portal, {
                portal: portal,
                children: _jsx(Popper, {
                    animationFunction: "productive",
                    arrowLabel: arrowLabel !== null && arrowLabel !== void 0 ? arrowLabel : accessibilityLabel,
                    arrowPadding: correctedArrowPadding,
                    arrowSize: correctedArrowSize,
                    children: returnedContent,
                    flip: !correctedPreventOverflow,
                    hasShadow: true,
                    hide: correctedPreventOverflow,
                    id: id,
                    isFixed: isFixed || !!portal,
                    isOpen: isOpen,
                    isRtl: isRtl,
                    onDismiss: handleClose,
                    placement: placement,
                    popperRef: popperRef,
                    popperStyles: popperStyles,
                    popperjsModifiers: popperjsModifiers,
                    preventOverflow: correctedPreventOverflow,
                    testID: testID,
                    triggerRef: triggerRef,
                    transitionProps: transitionProps,
                    zIndex: zIndex
                })
            })
        ]
    });
};
export default Flyout;
